/* eslint-disable */
/**
 * This file is included for backwards compatibility only.
 *
 * @deprecated
 */
const PLACEHOLDER_IMG =
  'data:image/png;base64,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';

const UNIT_PROPS = [
  'borderTopLeftRadius',
  'borderTopRightRadius',
  'borderBottomLeftRadius',
  'borderBottomRightRadius',
  'borderTopWidth',
  'borderRightWidth',
  'borderBottomWidth',
  'borderLeftWidth',
  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'paddingLeft',
];

const NAKED_PROPS = [
  'borderColor',
  'borderStyle',
  'opacity',
  'backgroundSize',
  'backgroundRepeat',
  'backgroundColor',
  'color',
  'overflowX',
  'overflowY',
];

const PARENT_PROPS = ['marginTop', 'marginRight', 'marginBottom', 'marginLeft'];

const POSITION_PROPS = ['top', 'left'];

export default {
  PLACEHOLDER_IMG,
  UNIT_PROPS,
  NAKED_PROPS,
  PARENT_PROPS,
  POSITION_PROPS,
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  INTEGER_PROPS: [].concat(UNIT_PROPS, PARENT_PROPS, POSITION_PROPS),
  DEFAULTS: {
    borders: {
      borderColor: 'transparent',
      borderStyle: 'solid',
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderTopWidth: 0,
      borderRightWidth: 0,
      borderBottomWidth: 0,
      borderLeftWidth: 0,
    },
    all: {
      version: 1,
      isColumn: false,
      gradient: null,
      backgroundRepeat: 'no-repeat',
      backgroundPositionX: 0,
      backgroundPositionY: 0,
      backgroundSize: 'auto',
      backgroundImage: null,
      backgroundColor: 'transparent',
      color: '#333333',
      rotate: 0,
      opacity: 1,
      borderColor: 'transparent',
      borderStyle: 'solid',
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderTopWidth: 0,
      borderRightWidth: 0,
      borderBottomWidth: 0,
      borderLeftWidth: 0,
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      position: 'normal',
      widthMode: 'em',
      maxWidth: 320,
      width: 320,
      top: 0,
      left: 0,
      scale: 1,
      height: 0,
      overflow: 'hidden',
    },
    TextBlock: {
      paddingTop: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 10,
    },
    ImageBlock: {
      height: 120,
    },
    YoutubeBlock: {
      height: 180,
      chromeless: true,
      fluid: true,
      autoplay: false,
    },
    InputBlock: {
      type: 'Text',
      placeholder: 'Placeholder text…',
    },
  },
};
